import React, { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { ListItemText } from "@mui/material";

const MuiSingleSelectMenu = ({
  id,
  name,
  options,
  onChange,
  onErrorChange,
  error,
  defaultValue,
  helperText,
}) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    if (defaultValue && defaultValue !== "" && !flag) {
      setSelectedOption(defaultValue);
      setFlag(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);


  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedOption(typeof value === "string" ? value.split(",") : value);
    onChange(event);
  };
  
  const handleValid = (event) => {
    const {
      target: { value },
    } = event;
    if(value && value !== ""){
      onErrorChange(null)
    }
  }

  return (
      <FormControl error= {error}>
        <InputLabel required id={id}>
          {id}
        </InputLabel>
        <Select
          label={id}
          name={name}
          value={selectedOption}
          onChange={handleChange}
          onBlur={handleValid}
          renderValue={(selected) =>
            options.find((e) => e.id === selected)?.name}
            >
          {options && options.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              <ListItemText primary={option.name} />
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
  );
};

export default MuiSingleSelectMenu;
